import { vehicleTypeMessages } from "@slfinrtl/ui-bff-routes"
import type { DataSource } from "@slfinrtl/ui-bff-routes"
import type { IntlShape } from "react-intl"
import { pricingFieldMessages } from "../hooks"
import type { AlwaysVatDeductibleBasicPricingFields } from "./alwaysVatDeductibleBasicPricing.fields"
import { alwaysVatDeductibleBasicPricingFieldNames } from "./alwaysVatDeductibleBasicPricing.fields"

export const getAlwaysVatDeductibleBasicPricingFields = (
	dataSource: DataSource | undefined,
	isDraft: boolean,
	formatMessage: IntlShape["formatMessage"],
	editListingPriceNewCars: boolean,
	vatDeductibleEnabled: boolean,
): AlwaysVatDeductibleBasicPricingFields => {
	const priceDisabledHint =
		!editListingPriceNewCars && (dataSource === "PVMS" || dataSource === "ONE_VMS")
			? formatMessage(pricingFieldMessages.editPriceDisabledForUSVMSVehicles, {
					value: dataSource === "PVMS" ? "PVMS" : "OneVMS",
				})
			: undefined

	return {
		minimumPrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.minimumPriceLabel),
			name: alwaysVatDeductibleBasicPricingFieldNames.minimumPriceName,
			type: "currency",
		},
		price: {
			debounced: isDraft ? 500 : undefined,
			disabledHint: priceDisabledHint,
			label: formatMessage(pricingFieldMessages.customerPriceLabel),
			maxLength: 17,
			name: alwaysVatDeductibleBasicPricingFieldNames.priceName,
			required: !priceDisabledHint,
			type: "currency",
		},
		purchasePrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.purchasePriceLabel),
			name: alwaysVatDeductibleBasicPricingFieldNames.purchasePriceName,
			type: "currency",
		},
		vatDeductible: vatDeductibleEnabled
			? {
					checked: true,
					disabledHint: formatMessage(pricingFieldMessages.notPossibleToEditVatDeductible, {
						vehicleType: formatMessage(vehicleTypeMessages.NEW_CAR),
					}),
					label: formatMessage(pricingFieldMessages.vatDeductibleLabel),
					name: alwaysVatDeductibleBasicPricingFieldNames.vatDeductibleName,
				}
			: undefined,
	}
}
